export const newline = {
  newline: {
    viewBox: [0, 0, 14, 14],
    shape:
      '<path d="M9.30042 6.45117L12.3004 9.45117L9.30042 12.4512" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M1.63379 1.45117V9.45117H11.6338" stroke="#979797" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>',
  },
};
